<section class="w-full flex flex-wrap justify-center items-center">
    <div class="w-full flex flex-wrap content-start bg-white dark:bg-gray-900 rounded-lg pt-4 pb-9 px-4">
        <div class="w-full flex flex-wrap relative">
            <div class="w-6/12 flex flex-wrap">
                <img class="w-6" src="https://cloud.behkhaan.ir/assets/icons/beh-logo.svg">
                <p class="w-full text-[#03121B] font-bold text-sm mt-2 line-clamp-1">{{data?.book.name}}</p>
                <span class="w-[18px] h-1 bg-green-500 mt-1"></span>
                @if(firstAuthor) {
                <p class="w-full text-gray-500 font-bold text-sm mt-2">{{firstAuthor}}</p>
                }
                @if (firstTranslator) {
                <p class="w-full text-gray-500 font-bold text-sm mt-1">{{firstTranslator}}</p>
                }

                @if (!firstTranslator && !firstAuthor) {
                <p class="w-full text-gray-500 font-bold text-sm mt-2">{{data?.book?.authors[0]?.name ?
                    data.book?.authors[0]?.name : data?.book?.authors[0]?.fullName}}</p>

                }
            </div>
            <div class="w-6/12 flex justify-end absolute left-0 -top-[55px] z-10"
                [ngClass]="{'-top-[57px]': !data.book?.hasPhoto }">
                <img class="w-[100px] h-[143px] rounded-xl"
                    [src]="data.book?.id| image : imageType.book : data.book?.hasPhoto">
            </div>
        </div>
        <div class="w-full flex flex-wrap mt-[17px] justify-between border-b border-[#CED3D7] pb-4">
            <div class="flex items-center">
                <span class="icon ruled-paper-regular text-green-500 ml-2"></span>
                <span class="font font-medium text-xs text-gray-500">{{'صفحه '+data.pageNum}}</span>

            </div>
            <span class="font-regular text-xs text-gray-500">{{data.actor?.userName + '@' }}</span>
        </div>
        <div class="w-full flex flex-wrap mt-4">
            <div class="w-full flex items-center justify-start">
                <span class="icon quote-filled text-green-500 ml-2"></span>
                <span class="icon quote-filled text-green-500"></span>
            </div>
            <p class="font-medium text-xs text-gray-700 text-justify my-2 line-clamp-[11]">{{data.body}}</p>
            @if (data.hasPhoto) {
            <img class="rounded-xl w-full my-2" [ngStyle]="{ 'aspect-ratio': inverseMediaRatio }"
                [src]="data?.mediaId| image : imageType.quote">
            }

            <div class="w-full flex items-center justify-end">
                <span class="icon quote-filled text-green-500 rotate-180 ml-2"></span>
                <span class="icon quote-filled text-green-500 rotate-180"></span>
            </div>

        </div>
    </div>
    <div class="flex flex-wrap flex-col justify-center items-center mt-4">
        <p class="text-xs text-gray-700 dark:text-gray-200 font-medium">بهخوان | شبکهٔ اجتماعی کتاب</p>

        <div class="relative w-full my-4">
            <div class="border-t border-gray-500 dark:border-gray-400 absolute top-1/2 left-0 right-0"></div>
            <p
                class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-green-10 dark:bg-green-1000 px-2 text-green-500 text-sm font-medium">
                behkhaan.ir</p>
        </div>
    </div>
</section>